<template>
  <router-view
    :progress="progress"
    :handle-next-event="goToNextOrCompleteQuestionnaire"
    @back="goToPreviousRoute"
  />
</template>

<script setup>
import ROUTE from '@shared/modules/assessment/router/names'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import useAssessmentStore from '@shared/modules/assessment/stores/useAssessmentStore.js'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const corporateStore = useCorporateStore()
const assessmentStore = useAssessmentStore()
const route = useRoute()
const router = useRouter()

const steps = (() => {
  // TODO find another way (either through user object, extracting corporate handling into shared, or through moving this capability to the checkup endpoints
  const corporate = corporateStore.corporate
  const phqEnabled =
    corporate?.key === 'uhcmedsupp' ||
    sessionStorage.getItem('msk-us::phq-gad-assessment') === '1'

  return [
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAIN_AVERAGE,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAIN_WORST,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAIN_NOW,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_CHORES,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_STAIRS,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_WALK,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHYSICAL_ACTIVITY_ERRANDS,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_FEAR_OF_MOVEMENT,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PRODUCTIVITY,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_CONFIDENCE,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAST_CONSULTATIONS,
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PAST_MEDICATIONS,
    ...(phqEnabled
      ? [
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHQ_INTEREST,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_PHQ_FEELING,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_NERVOUS,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_CONTROL,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_WORRYING,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_RELAXING,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_RESTLESS,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_IRRITABLE,
          ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_GAD_AFRAID,
        ]
      : []),
    ROUTE.ASSESSMENT_SELF_TEST_REEVALUATIONS_COMPLETE,
  ]
})()

const progress = computed(() => {
  const currentStep = Math.max(
    0,
    steps.findIndex((step) => step === route.name),
  )
  return currentStep / steps.length
})

const getRouteProperties = (modifier) => {
  const index = steps.indexOf(route.name) + modifier

  if (typeof index !== 'number' || index < 0 || index >= steps.length) {
    throw new Error(
      `selfTestNavigation Mixin: Route cannot be determined because the target index is out of bounds. Current route name: ${route.name}, modifier: ${modifier}, target index: ${index}`,
    )
  }

  return { name: steps[index] }
}

const goToNextOrCompleteQuestionnaire = async () => {
  try {
    const routeProperties = getRouteProperties(+1)
    await router.push(routeProperties)
  } catch {
    // complete questionnaires;
    await assessmentStore.completeQuestionnaire(router)
  }
}

const goToPreviousRoute = () => {
  const routeProperties = getRouteProperties(-1)
  router.push(routeProperties)
}
</script>
